import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { switchMap } from 'rxjs/operators';

import * as ResumeActions from './resume.actions';
import { AppService } from '../../app.service';
import { ResumeItem, ResumeProps } from './resume.models';
import { environment } from '../../../environments/environment';

@Injectable()
export class ResumeEffects {
  loadResumes$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(ResumeActions.loadResumes),
      switchMap(() => {
        return this.resumeServices
          .get('resumes', '', {
            appId: environment.appId,
          })
          .then((resumes: ResumeItem[]) =>
            ResumeActions.loadResumesSuccess({ resumes })
          )
          .catch((error: any) =>
            ResumeActions.loadResumesFailure({ error: error.response.data })
          );
      })
    );
  });

  constructor(
    private actions$: Actions,
    private resumeServices: AppService<ResumeProps[]>
  ) {}
}
